import {BitrixVue} from 'ui.vue3';

export const ItemEditBtns = {
    props: {
        action: String
    },
    template: `
     <button class="element-edit-button ">
        <span class="element-edit-button__text js-editable">
            <slot>Редактировать элемент</slot>
        </span>
    </button>
    `
}